import { AssetSpec, SpineAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { DefaultLayout } from "@westpierstudio/luma/layout";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { MinimumHeightSpec, minimumHeightSpecSelector, orientationSpecSelector } from "utils/Responsive";

interface ReelTopDragonPandaSpec extends AssetSpec {
    portraitDragon : MinimumHeightSpec[],
    portraitPanda : MinimumHeightSpec[]
    dragon : SpineAssetSpec,
    panda : SpineAssetSpec
}

export class ReelTopDragonPanda extends View {
    private spec : ReelTopDragonPandaSpec;
    private dragon : Spine;
    private panda : Spine;
    private darkenTint: number;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, resources} = services;

        const spec = this.spec = resources.getSpec(`reeltopdragonpanda`) as ReelTopDragonPandaSpec;
        factory.applySpec(this, spec);
        this.dragon = factory.createSpine(spec.dragon, this);
        this.panda = factory.createSpine(spec.panda, this);

        this.darkenTint = parseInt(resources.getSpec(`vsresultpanels`).darkenTint);

        this.resize();
        services.layout.onResize.add(() => this.resize());
    }

    resize() {
        if (this.services.layout.landscape) {
            this.visible = false;
        }
        else {
            this.visible = true;
            this.services.factory.applySpec(this.dragon, minimumHeightSpecSelector(this.services, this.spec.portraitDragon));
            this.services.factory.applySpec(this.panda, minimumHeightSpecSelector(this.services, this.spec.portraitPanda));
        }
    }

    tintDragon() {
        this.dragon.tint = this.darkenTint;
    }

    tintPanda() {
        this.panda.tint = this.darkenTint;
    }

    clearTints() {
        this.dragon.tint = 0xFFFFFF;
        this.panda.tint = 0xFFFFFF;
    }
}